module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_flower-44a815c3fdc35f2e124a9bac235c9c82.png";